/**
 * Data normalization utilities for handling backward compatibility
 * and data format consistency across ViewModels
 */

/**
 * Issue 2.2: Normalize product types from both old (string) and new (array) formats
 * Handles backward compatibility for legacy productType field
 * @param {Object} productData - Product document from database
 * @returns {Array<string>} Array of product types
 */
export function normalizeProductTypes(productData) {
    // New format: productTypes array
    if (Array.isArray(productData.productTypes) && productData.productTypes.length > 0) {
        return productData.productTypes;
    }
    // Legacy format: productType string (backward compatibility)
    if (productData.productType) {
        return [productData.productType];
    }
    // Fallback: no product types defined
    return [];
}

/**
 * Issue 2.2: Normalize image array from string URLs to object format
 * Ensures consistent image object structure across ViewModels
 * @param {Array|*} images - Raw images data from database
 * @returns {Array<Object>} Array of normalized image objects with url property
 */
export function normalizeImages(images) {
    if (!Array.isArray(images)) return [];
    if (images.length === 0) return [];
    
    // Already in object format with url property
    if (typeof images[0] === 'object' && images[0].url) {
        return images;
    }
    
    // String URLs - convert to objects
    if (typeof images[0] === 'string') {
        return images.map(url => ({ url, title: '', description: '' }));
    }
    
    return [];
}
